import { render } from "./online-order.vue?vue&type=template&id=2cdce5e3"
import script from "./online-order.vue?vue&type=script&lang=js"
export * from "./online-order.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__